import React, { useState, useEffect, useCallback } from 'react'
import Select from '../../dpe-usco/components/Select/Select'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { Button } from 'syngenta-react-components'
import { getGrowersNamesFromProdPlan, postScaleTicket } from '../../services/apiHelper'
import { useParams } from 'react-router-dom'
import error_outline from '../../assets/icons/error_outline.svg'
import arrow_forward from '../../assets/icons/arrow_forward.svg'
import close from '../../assets/icons/close.svg'
import greenCheck from '../../assets/icons/circle_check_green.svg'
import _ from 'lodash'

const CheckGrowerModal = ({ tableData, visibility, toggleModal, clear, setPageRefresh, allScaleTickets, ticketsLoaded }) => {
  const { production_plan_id } = useParams()
  const [growersFromProdPlan, setGrowersFromProdPlan] = useState([])
  const [growersFromFile, setGrowerFromFile] = useState([])
  const [missingGrowers, setMissingGrower] = useState([])
  const [cloneTableData, setCloneTableData] = useState()
  const [changedGrowers, setChangedGrowers] = useState([])
  const [status, setStatus] = useState('INIT')
  const [statusMessage, setStatusMessage] = useState([])
  const [pendingSave, setPendingSave] = useState(false)
  useEffect(() => {
    setStatus('LOADING')
    if (tableData?.length) {
      let growerList = tableData?.map(obj => {
        return {
          value: obj?.Grower?.trim(),
          index: obj?.Index,
          external_reference_id: obj['Contract Number'],
          original_new_contract_id: obj['New Contract Id']
        }
      })
      setCloneTableData(JSON.parse(JSON.stringify(tableData)))
      setGrowerFromFile(growerList)
    }
    setStatus('INIT')
  }, [
    growersFromProdPlan.length, production_plan_id, tableData
  ])


  useEffect(() => {
    getGrowersNamesFromProdPlan(production_plan_id).then(res => {
      let growerList = res?.data?.contracts
      if(growerList.length)
        growerList.sort(function(a, b) {
          const fName = a?.contract_details?.grower_details?.first + ' ' + a?.contract_details?.grower_details?.last
          const sName = b?.contract_details?.grower_details?.first + ' ' + b?.contract_details?.grower_details?.last
          var textA = fName.toUpperCase()
          var textB = sName.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      
      let options = growerList.flatMap(contractObj => {
        const first = contractObj?.contract_details?.grower_details?.first
        const last = contractObj?.contract_details?.grower_details?.last
        if (first && last && (contractObj.contract_state === 'completed' || contractObj.contract_state === 'amendment_completed')) {
          return {
            value: <div>{first+' '+last}<br/> {contractObj.new_contract_id? contractObj.new_contract_id:'NA'}</div>,
            sap_id: contractObj?.contract_details?.grower_details?.sap_id,
            external_reference_id: contractObj.contract_id,
            new_contract_id: contractObj.new_contract_id
          }
        } else {
          return []
        }
      })
      setGrowersFromProdPlan(options)
    })
  }, [
    production_plan_id
  ])

  const compareGrowers = useCallback((_growersFromFile, _growersFromProdPlan) => {
    let noMatchFromFile = []
    if (_growersFromProdPlan?.length && _growersFromFile?.length) {
      noMatchFromFile = _growersFromFile.filter(o1 => _growersFromProdPlan.some(o2 => o1?.value?.toString().toLowerCase() !== o2?.value?.toString().toLowerCase()))
    }
    return noMatchFromFile
  }, [])

  const condenseGrowersArr = missingGrowers  => {
    let dupes = []
    missingGrowers.forEach(item => {
      dupes[item.value] = dupes[item.value] || []
      dupes[item.value].push(item.index)
    })
    return Object.keys(dupes).map(grower => {
      return { value:grower, index: dupes[grower] }
    })
  }

  useEffect(() => {
    const noContractNumber = growersFromFile.filter(obj => !obj.external_reference_id)
    const noGrowerMatch = compareGrowers(growersFromFile, growersFromProdPlan)
    const unionMissing = _.unionBy(noGrowerMatch, noContractNumber)
    const condensedUnionMissing = condenseGrowersArr(unionMissing)
    setMissingGrower(condensedUnionMissing)
  }, [
    compareGrowers, growersFromFile, growersFromProdPlan
  ])

  const handleChange = (replacer, event, selectIndex) => {
    let currentGrower = missingGrowers[selectIndex]
    if (currentGrower) {
      cloneTableData.forEach(obj => {
        currentGrower.index.forEach(index =>{
          if (obj.Index === index) {
            obj.Grower = replacer.value.props.children[0]
            obj.value = replacer.value
            currentGrower.assigned = replacer.value
            obj['Contract Number'] = replacer.external_reference_id
            obj['New Contract Id'] = replacer.new_contract_id
          }})
      })
    }

    if (!changedGrowers.includes(selectIndex)) {
      setChangedGrowers(prev => prev.concat(selectIndex))
    }
  }

  const isFuzzyMatch = array => {
    var A= array.concat().sort(), 
      a1= A[0], a2= A[A.length-1], L= a1.length, i= 0
    while(i<L && a1.charAt(i)=== a2.charAt(i)) i++
    return a1.substring(0, i).length
  }

  const MatchGrowerList = ({ growersFromProdPlan, missingGrowers }) => {
    return missingGrowers.map((obj, index) => {

      let matchValue = {}
      let matchDataValue = {}
      if(!Object.prototype.hasOwnProperty.call(missingGrowers[index],'assigned')) {         
        growersFromProdPlan.forEach(data => {
          if(data.value?.props?.children[0]?.length > 2 && obj.value?.length > 2 )
          {
            let matchFirstLength = -1
            let matchLastLength = -1

            let fuzzyMatchFirstLength = -1
            let fuzzyMatchLastLength = -1

            const missingGrowerSplitVal = obj.value.split(/ (.*)/,2)
            const GrowerSplitVal = data.value?.props?.children[0].split(/ (.*)/,2)

            if(missingGrowerSplitVal.length > 1 && GrowerSplitVal.length > 1) 
            {
              const missingGrowersFirstname = (missingGrowerSplitVal[0].length > 2)? missingGrowerSplitVal[0].toLowerCase() : '' 
              let missingGrowersLastname = (missingGrowerSplitVal[1].length > 2)? missingGrowerSplitVal[1].toLowerCase() : ''

              const growersFirstname = (GrowerSplitVal[0].length > 2)? GrowerSplitVal[0].toLowerCase() : ''
              const growersLastname = (GrowerSplitVal[1].length > 2)? GrowerSplitVal[1].toLowerCase() : ''

              if(missingGrowersFirstname !== '' 
                      && growersFirstname !== '' 
                      && missingGrowersLastname !== '' 
                      && growersLastname !== '')
              {
                fuzzyMatchFirstLength = isFuzzyMatch([missingGrowersFirstname,growersFirstname])
                fuzzyMatchLastLength = isFuzzyMatch([missingGrowersLastname,growersLastname])

                if(fuzzyMatchFirstLength < 4 && fuzzyMatchLastLength < 4){
                  fuzzyMatchFirstLength = isFuzzyMatch([missingGrowersFirstname,growersLastname])
                  fuzzyMatchLastLength = isFuzzyMatch([missingGrowersLastname,growersFirstname])
                }

                if(fuzzyMatchFirstLength >= 3 && fuzzyMatchLastLength >= 3){
                  if(data.value?.props?.children[0] === matchValue?.props?.children[0])
                  {
                    if((parseInt(data.value?.props?.children[3].slice(-2))  < parseInt(matchValue?.props?.children[3].slice(-2)))
                          && (data.value?.props?.children[3].length > 2 && matchValue?.props?.children[3].length > 2)
                    )
                    {
                      matchValue = data.value
                      matchDataValue = data
                    }
                  } else {
                    if((fuzzyMatchFirstLength > matchFirstLength) || (fuzzyMatchLastLength > matchLastLength)) {
                      matchFirstLength = fuzzyMatchFirstLength
                      matchLastLength = fuzzyMatchLastLength
                      matchValue = data.value
                      matchDataValue = data
                    }
                  }
                }
              }
            }
          }
        })

        if(Object.keys(matchValue).length!==0) {
          handleChange(matchDataValue,'',index)
        }
      }

      return (
        <div className='df fxdr fxww w100%' key={index}>
          <span className='df fxdrc flx1 jcc aib h40'>{obj.value}</span>
          <div className='df fxdrr flx1'>
            <img className='mr24' src={arrow_forward} alt='arrow pointing right' />
            <Select
              defaultValue={Object.keys(matchValue).length!==0?matchValue:missingGrowers[index].assigned}
              placeholder='Match to Grower'
              handleSelection={handleChange}
              options={growersFromProdPlan}
              name='growerNames'
              id='growerNames'
              reset={false}
              index={index}
            />
          </div>
        </div>
      )
    })
  }

  const massageForPost = arr => {
    let returnArr = arr.map(ticket => {
      return {
        bill_of_landing_number: ticket.BOL?.toString(),
        external_reference_id: ticket['Contract Number']?.toString(),
        original_new_contract_id: ticket['New Contract Id']?.toString(),
        damage: ticket.DMG?.toString(),
        foreign_material: ticket.FM?.toString(),
        gross_lbs: ticket['Gross Weight']?.toString(),
        gross_quantity: ticket['Gross Qty']?.toString(),
        grower_name: ticket.Grower?.toString(),
        moisture: ticket.MST?.toString(),
        net_lbs: ticket['Net Weight']?.toString(),
        net_quantity: ticket['Net Qty']?.toString(),
        production_plan_id: production_plan_id?.toString(),
        rapid_visco_analyzer: ticket.RVA?.toString(),
        scale_ticket_number: ticket['Ticket Number'] && ticket['Ticket Number'].scale_ticket_id?.toString(),
        scale_ticket_date: new Date(ticket.Date),
        tar_lbs: ticket.Tare?.toString(),
        test_weight: ticket['Test Weight']?.toString(),
        ...((ticket.notes?.toString() || ticket.Notes?.toString()) && { notes: ticket.notes?.toString()? ticket.notes?.toString() : ticket.Notes?.toString() ? ticket.Notes?.toString() : null })
      }
    })
    return {
      scale_tickets: returnArr
    }
  }

  const checkDupWithDB = () => {
    const dupTickets = []
    cloneTableData.forEach(ticket => {
      const grower = ticket.Grower?.trim()
      const date = ticket.Date
      const ticketNumber = ticket['Ticket Number']?.scale_ticket_id
      const bol = ticket.BOL
      const netQty = ticket['Net Qty']

      const match = allScaleTickets?.find(existing => {
        const sameDateGrower = existing.date === date && existing.grower === grower
        if (ticketNumber && existing.ticketNumber) {
          return sameDateGrower && existing.ticketNumber === ticketNumber
        }
        if (bol && existing.bol) {
          return sameDateGrower && existing.bol === bol
        }
        return sameDateGrower && existing['Net Qty'] === netQty
      })

      if (match) {
        dupTickets.push({ ticket, existing: match })
      }
    })
    return dupTickets
  }

  const saveHandler = async () => {
    if (!ticketsLoaded) {
      setStatus('LOADING')
      setPendingSave(true)
      return
    }
    await runSave()
  }

  const runSave = async () => {
    const dups = checkDupWithDB()
    if (dups.length) {
      setStatus('DUPBD')
      setStatusMessage(dups)
      return
    }
    setStatus('LOADING')
    setStatusMessage([])
    let response = await postScaleTicket(massageForPost(cloneTableData))
    if (response.status === 200) {
      setStatus('SUCCESS')
    } else {
      setStatus('ERROR')
      setStatusMessage(response.data.errors)
    }
  }

  useEffect(() => {
    if (ticketsLoaded && pendingSave) {
      setPendingSave(false)
      runSave()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketsLoaded, pendingSave])

  const closeHanlder = () => {
    if (status === 'SUCCESS') {
      setStatus('INIT')
    }
    toggleModal(false)
    setPageRefresh(true)
  }

  const renderContent = status => {
    let content
    switch (status) {
      case 'INIT':
        content = (<>
          <div className='bb1-s-lightgray df jcsb'>
            <div className='df ml15 mt15 mb15'>
              <img src={error_outline} alt='error icon' />
              <div className='ml10'>
                Check Grower Names
              </div>
            </div>
            <img className='mr15 curp' onClick={closeHanlder} src={close}
              alt='close icon'>
            </img>
          </div>
          <div>
            <div className='df fxdrc p15'>
              <span className='mt20'>Resolve <span className='fw600'>{missingGrowers.length}</span> unmatched growers or contract:</span>
              <div className='mt10'>
                <MatchGrowerList growersFromProdPlan={growersFromProdPlan} missingGrowers={missingGrowers} />
              </div>
            </div>
          </div>
        </>)
        break
      case 'DUPBD': {
        content = <div>
          <div className='bb1-s-lightgray df jcsb'>
            <div className='df ml15 mt15 mb15'>
              <img src={error_outline} alt='error icon' />
              <div className='ml10'>
                Duplicate{statusMessage?.length > 1 ? 's' : ''} found — already saved in the database
              </div>
            </div>
            <img className='mr15 curp' onClick={closeHanlder} src={close} alt='close icon' />
          </div>
          <div className='pl20 pr20 pb40'>
            <p className='fw600 mb10 mt15 tal pl0'>
              The following ticket{statusMessage?.length > 1 ? 's' : ''} already exist. Edit and reupload the corrected source file to continue.
            </p>
            {statusMessage?.map((dup, i) => (
              <div key={i} className='bd1-s-lightgray bdrs-4 p10 mb10'>
                <div className='fw600 mb4'>Row {dup.ticket.Index} — duplicate with existing record:</div>
                <div className='fz13'>
                  <span className='mr16'><span className='fw600'>Grower: </span>{dup.existing.grower}</span>
                  <span className='mr16'><span className='fw600'>Date: </span>{dup.existing.date}</span>
                  {dup.existing.ticketNumber && <span className='mr16'><span className='fw600'>Ticket #: </span>{dup.existing.ticketNumber}</span>}
                  {dup.existing.bol && <span className='mr16'><span className='fw600'>BOL: </span>{dup.existing.bol}</span>}
                  <span><span className='fw600'>Net Qty: </span>{dup.existing['Net Qty']}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        break
      }
      case 'ERROR': {
        content = <div>
          {statusMessage?.length > 0 && statusMessage[0]?.key_path === 'scale_ticket_duplication' ?
            <>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <img src={error_outline} alt='error icon' />
                  <div className='ml10'>
                    Duplicate scale ticket{statusMessage?.length > 1 && 's' } found which already exists
                  </div>
                </div>
                <img className='mr15 curp' onClick={closeHanlder} src={close}
                  alt='close icon'>
                </img>
              </div>
              <div className='pl20 pb40'>
                <p className="fw600 mb10 tal pl0">Duplicate record{statusMessage?.length > 1 && 's' }:</p>
                {statusMessage?.map(data =>  
                  <div>{data.message}</div>
                )} 
              </div>
            </> : 
            <>
              <div className='bb1-s-lightgray df jcsb'>
                <div className='df ml15 mt15 mb15'>
                  <img src={error_outline} alt='error icon' />
                  <div className='ml10'>
                     Error uploading scale ticket
                  </div>
                </div>
                <img className='mr15 curp' onClick={closeHanlder} src={close}
                  alt='close icon'>
                </img>
              </div>
              <div className='pl20 pb40'>
                {statusMessage?.map(data =>  
                  <p className='tal'>{data.message}</p>
                )} 
              </div>
            </>
          }
        </div>
        break
      }
      case 'SUCCESS': {
        content = (<div className='df jcc p20'>
          <img src={greenCheck} alt='check mark'></img>
          <div className='ml10'>Scale tickets successfully saved.</div>
        </div>)
        break
      }
      case 'LOADING':
        content = <TableStatus status='LOADING'></TableStatus>
        break
      default:
        break
    }
    return content
  }

  return (
    <div className="modalContainer" style={{ display: visibility ? 'block' : 'none' }}>
      <div className="aHModalChild posr t100" style={{ 'maxWidth': '900px' }}>
        <div className='w100% tal h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4 mb40'>
          {renderContent(status)}
          {status !== 'LOADING' && <div className='bt1-s-lightgray df aic jcfe'>
            <div className='mt8 mb8 mr8'>
              <Button customClassName='mr8 miw75 pl1 pr1' text='Close' onClick={closeHanlder} />
              {status === 'INIT' && <Button customClassName='miw70' disabled={missingGrowers?.length !== changedGrowers?.length} type='success' text='Save' onClick={saveHandler} />}
            </div>
          </div>}
        </div>
      </div>
    </div>
   
  )
}

export default CheckGrowerModal